import { selectGtoState, useDispatch, gerenciaTecnicaSlice } from "../../../../stateManagement/redux"
import ButtonCircle from "../../../../shared/components/button_circle"
import ButtonBig from "../../../../shared/components/button_big"
import { useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import ReportCard from "../../reports_viewer/cart_with_info/card";
import generatePDF, { Options } from 'react-to-pdf';
import { validateAndFormatNumber } from "../../../../stateManagement/redux/slices/gerencia_tecnica/auxiliarFunctions";
import { validationTypeEnum } from "../../../../stateManagement/redux/slices/gerencia_tecnica/interfaces";
import { validateAndConvertFraction } from "../../../../shared/util/validateFunction";
import { projectList } from "../../../../shared/util/projectList";
import { UploadActivitiesModal } from "./uploadActivityModal";
import { delay } from "./fileRow";
import { StatesTabs } from "./statesTabs";
import { GeneralTab } from "./generalTab";
import { ActivitiesList } from "./activitiesList";
import { CartsList } from "./cartsList";
import { ButtonsTab } from "./buttonsTab";
import { ErrorList } from "./errorList";
import { uploadConsolidatedActivities } from "../../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers";
import { set } from "react-datepicker/dist/date_utils";
import { compareStringsAccentInsensitive } from "../../../../shared/util/compare";
import { checkErrors } from "./checkErros";
import { getGroupAssignedConfig } from "src/shared/util/requestDataServer";

export const UploadModal = ({ close, originalFlow }: { close: any, originalFlow: string }) => {

    const dispatch = useDispatch();

    const targetRef = useRef<any>();

    const mainState = useSelector(selectGtoState);

    const [showCartModalReport, setshowCartModalReport] = useState(false)

    const [showListOfActivities, setShowListOfActivities] = useState(false)

    const [activeFieldForActivities, setActiveFieldForActivities] = useState('')

    const [executedDate, setExecutedDate] = useState<any>(null);

    const [numeroCuadrilla, setNumeroCuadrilla] = useState<number>();

    const [filterStates, setFilterStates] = useState([
        { id: "summary", name: "Generalidades", amountElement: 0 },
        { id: "activities", name: "Actividades", amountElement: 0 },
        { id: "carts", name: "Cartas", amountElement: 0 },
        { id: "errors", name: "Errores", amountElement: 0 },
        { id: "files", name: "Archivos", amountElement: 0 },
    ])

    const [activities, setActivities] = useState<any[]>([])

    const [cuadrillas, setCuadrillas] = useState<any[]>([])

    const [errors, setErrors] = useState<any>([])

    const [sortActivities, setSortActivities] = useState<any[]>([])

    const [carts, setCarts] = useState<any[]>([])

    const [actveActivityWithCard, setActveActivityWithCard] = useState<any>([])

    const [ActiveCuadrilla, setActiveCuadrilla] = useState("")

    const [activeState, setActiveState] = useState(filterStates[0].id)

    const [setSizeToGeneratePdf, setsetSizeToGeneratePdf] = useState(false)

    const [reloadCartComponent, setReloadCartComponent] = useState(false)

    const [uploadTaskWithVariables, setUploadTaskWithVariables] = useState(false)

    const [groupAssignedConfig, setGroupAssignedConfig] = useState<any>()

    const [groupAssigned, setgroupAssigned] = useState<any>()

    const onClickVerActividades = (c: any) => {
        setActiveCuadrilla(c.member)
        setActiveState('activities')
    }

    const onChangeActivitiesField = (fieldName: string, preValue: string, newValue: string) => {

        let newActivities = mainState?.activitiesWithCarts?.map((a) => {
            const element = { ...a }

            if (element[fieldName] === preValue) {
                element[fieldName] = newValue
            }

            return element
        })

        let newCards = mainState?.cardsWithActivities?.map((a) => {
            const element = { ...a }

            if (element[fieldName] === preValue) {
                element[fieldName] = newValue
            }
            return element
        })

        newActivities = newActivities?.map((a) => {
            const element = { ...a }
            const cart = newCards?.find((cart: any) => cart.location === a['Pozo'])
            element.haveCart = cart ? true : false
            return element
        })

        newCards = newCards?.map((a) => {
            const act = newActivities?.find((activity: any) => activity['Pozo'] === a.location)

            let element;

            if (!act) {
                element = {
                    haveActivity: false,
                    haveCart: false,
                    location: a.location,
                    Pozo: a.Pozo,
                    "Pump Card Load": a['Pump Card Load'],
                    "Pump Card Position": a['Pump Card Position'],
                    "Surface Card Load": a['Surface Card Load'],
                    "Surface Card Position": a['Surface Card Position']
                }

            } else {
                element = {
                    ...a,
                    ...act,
                    haveActivity: true,
                    haveCart: true
                }
            }
            return element
        })

        if (newActivities) {
            dispatch(gerenciaTecnicaSlice.actions.setActivitiesWithCarts(newActivities));
        }

        if (newCards) {
            dispatch(gerenciaTecnicaSlice.actions.setCardsWithActivities(newCards));
        }

    }

    const onClose = () => {
        close()
        setErrors([])
        setCuadrillas([])
    }


    useEffect(() => {
        // set Cuadrillas

        const cuadrillas: any[] = []

        const activities: any[] = []

        setErrors([])
        setCuadrillas([])

        mainState?.activitiesWithCarts?.forEach((a) => {

            let keyForSquatMembers = 'Ingenieros'

            if (a?.[keyForSquatMembers] === undefined) {
                const validation = mainState.taskValidations || []
                const personalNameHomologations = validation.find((v: any) => v.name === "Ingenieros")?.homologation || []

                const newKeyForSquatMembers = personalNameHomologations.find((h: any) => Object.keys(a).includes(h))

                if(newKeyForSquatMembers) {
                    keyForSquatMembers = newKeyForSquatMembers
                }
                
            }


            try {
                const cuadrilla = cuadrillas.find((c) => compareStringsAccentInsensitive(c.member, a?.[keyForSquatMembers]))

                if (cuadrilla) {
                    cuadrilla.activities += 1
                    if (a?.haveCart) {
                        cuadrilla.carts += 1
                    }
                } else {

                    const guestMembers: any[] = []

                    a?.[keyForSquatMembers].split('/').forEach((m: string) => {
                        const userExist = mainState?.users?.find((u) => compareStringsAccentInsensitive(u.name, m))
                        if (!userExist) {
                            guestMembers.push(m.trim())
                        }
                    })

                    cuadrillas.push({ member: a?.[keyForSquatMembers], activities: 1, carts: a?.haveCart ? 1 : 0, guestMembers })

                }

                const locationExistInDb = mainState.locations?.find(location => location.name === validateAndFormatNumber(a?.Pozo, activeFieldForActivities))

                activities.push({ line: a.position, location: `${activeFieldForActivities} ${a?.Pozo}`, members: a?.[keyForSquatMembers], haveCart: a?.haveCart ? 'SI' : 'NO', isNameOk: locationExistInDb ? true : false })

            } catch (error) {

            }
        })

        const carts: any[] = []

        mainState?.cardsWithActivities?.forEach((c) => {

            carts.push({ locationCart: `${activeFieldForActivities} ${c.location}`, LocationActivity: `${c?.Pozo ? `${activeFieldForActivities} ${c?.Pozo}` : ''}`, source: c.type, haveActivity: c.haveActivity })
        })


        setCarts(carts)
        setCuadrillas(cuadrillas)

        checkErrors({
            mainState, executedDate, activeFieldForActivities,
            cuadrillas, setSortActivities, setErrors, setFilterStates,
            filterStates, originalFlow, numeroCuadrilla, groupAssigned
        })
        setActivities(activities)

    }, [mainState?.activitiesWithCarts, mainState?.cardsWithActivities, activeFieldForActivities, executedDate, numeroCuadrilla, groupAssigned])

    useEffect(() => {
        getGroupAssignedConfig().then((data) => {
            setGroupAssignedConfig(data)
        })
    }, [])

    useEffect(() => {

        let fieldCode = '0'

        if (activeFieldForActivities && activeFieldForActivities !== '') {
            const field = groupAssignedConfig?.field.find((x:any) => x.id === activeFieldForActivities)
            if (field) {
                fieldCode = field.code.toString().padStart(1, '0')
            }
        }

        let activityCode = '0'

        console.log({originalFlow,groupAssignedConfig})

        if (originalFlow && originalFlow !== '') {
            const activity = groupAssignedConfig?.activity.find((x:any) => x.id === originalFlow)
            if (activity) {
                activityCode = activity.code.toString().padStart(2, '0')
            }
        }

        let squadCode = numeroCuadrilla ? numeroCuadrilla.toString().padStart(1, '0') :''

        const groupActivityId = `${fieldCode}${activityCode}${squadCode}`

        if (groupActivityId){
            setgroupAssigned(groupActivityId)
        }

    }, [groupAssignedConfig, activeFieldForActivities,numeroCuadrilla,originalFlow])
    

    const onClickViewCartFromActivity = (c: any) => {

        const location = c?.location?.replace(activeFieldForActivities, '').trim()

        const activity = mainState?.activitiesWithCarts?.find((a) => a.Pozo === location)

        setActveActivityWithCard(activity)

        setshowCartModalReport(true)

        setShowListOfActivities(false)
    }

    const onClickViewCartFromCard = (c: any) => {

        setShowListOfActivities(false)

        const location = c?.locationCart?.replace(activeFieldForActivities, '').trim()

        const activity = mainState?.cardsWithActivities?.find((a) => a.location === location)

        setActveActivityWithCard(activity)

        setshowCartModalReport(true)

    }

    const onClickDownnloadPdf = async () => {

        if (showListOfActivities) {
            setShowListOfActivities(false)

            for (const activity of mainState?.cardsWithActivities || []) {
                setActveActivityWithCard(activity)
                setReloadCartComponent(true)
                await delay(500)
                setsetSizeToGeneratePdf(true)
                setReloadCartComponent(false)
                await delay(1000)

                const options: Options = {
                    filename: `${activity?.['Pozo']}.pdf`,
                    method: 'save',
                    page: { format: 'letter', orientation: 'landscape', margin: { top: 22, right: 22, bottom: 22, left: 22 } },
                    overrides: { pdf: { compress: true } },
                    canvas: { qualityRatio: 0.2 }
                }

                await generatePDF(targetRef, options)

            }
            setsetSizeToGeneratePdf(false)
            setShowListOfActivities(true)

        } else {
            setReloadCartComponent(true)
            await delay(500)
            setsetSizeToGeneratePdf(true)
            setReloadCartComponent(false)
            await delay(1000)

            const options: Options = {
                filename: `${actveActivityWithCard?.['Pozo']}.pdf`,
                method: 'open',
                page: { format: 'letter', orientation: 'landscape', margin: { top: 22, right: 22, bottom: 0, left: 22 } },
                // page: { format: 'letter', orientation: 'landscape', margin: { top: 22, right: 10, bottom: 0, left: 10 } },
                overrides: { pdf: { compress: true } },
                canvas: { qualityRatio: 0.2 }
            }

            generatePDF(targetRef, options)
            setsetSizeToGeneratePdf(false)
        }
    }

    const onClickShowPdfList = async () => {
        setshowCartModalReport(true)
        setShowListOfActivities(true)
    }

    const onClickUploadActivities = () => {

        let errorNe001 = false

        Object.keys(errors).forEach((key: string) => {
            (errors[key] as any[]).forEach((e: any) => {
                if (e.error.includes('NE-001')) {
                    errorNe001 = true
                }
            })
        })

        let step = errorNe001 ? 'Validate NE001' : 'CheckWsMessage'

        dispatch(gerenciaTecnicaSlice.actions.setUploadingStep(step))

        // if (step === 'Uploading') {
        //     dispatch(uploadConsolidatedActivities(sortActivities, executedDate))
        // }

        setUploadTaskWithVariables(true)
    }


    return (
        <>
            {uploadTaskWithVariables &&
                <UploadActivitiesModal
                    executedDate={executedDate}
                    sortActivities={sortActivities}
                    close={() => setUploadTaskWithVariables(false)}
                />}
            {showCartModalReport &&
                <div className='consolidate_files_container_modal_cart_report'>
                    <div className="consolidate_files_container_modal_cart_report_input_container" >
                        <div className="consolidate_files_container_header">
                            <div>Resumen Actividad Dinamometrica</div>
                            <ButtonCircle icon="/assets/icons/close.svg" iconHeight={15} iconWidth={15} onClick={() => setshowCartModalReport(false)} />
                        </div>
                        <div className="consolidate_files_container_modal_cart_report_button_container">
                            <ButtonBig text='Generar PDF' icon='/assets/icons/download-report.svg' onClick={() => onClickDownnloadPdf()} />
                            <ButtonBig text='Calcular Carta fondo' icon='/assets/icons/calculate.svg' onClick={() => { }} />
                        </div>
                        <div className="consolidate_files_container_modal_cart_list_scroll">
                            {showListOfActivities ? (
                                <>
                                    {mainState?.cardsWithActivities?.map((a, i) => (
                                        // <div ref={targetRef} key={i}>
                                        <ReportCard
                                            activeActivityWithCard={a}
                                            key={i}
                                            activityValidation={mainState?.taskValidations}
                                            activeFieldForActivities={activeFieldForActivities}
                                            targetRef={targetRef}
                                            setSizeToGeneratePdf={false}
                                        />
                                        // </div>
                                    ))}
                                </>
                            ) : (
                                <>
                                    {!reloadCartComponent && ((
                                        // <div ref={targetRef} className={`${setSizeToGeneratePdf ? "consolidate_files_container_letter_container" : ""}`}>
                                        // <div ref={targetRef}>
                                        <ReportCard
                                            activityValidation={mainState?.taskValidations}
                                            activeActivityWithCard={actveActivityWithCard}
                                            activeFieldForActivities={activeFieldForActivities}
                                            targetRef={targetRef}
                                            setSizeToGeneratePdf={setSizeToGeneratePdf}
                                        />
                                        // </div>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>
                </div>}
            {/* <div className='consolidate_files_container_external_container' > */}
            <div className='consolidate_files_container_info_container' >
                <div className="consolidate_files_container_header">
                    <div>Validar la Información antes de consolidar</div>
                    <ButtonCircle icon="/assets/icons/close.svg" iconHeight={15} iconWidth={15} onClick={onClose} />
                </div>
                <div className="consolidate_files_container_body">
                    <StatesTabs tabs={filterStates} activeState={activeState} setActiveState={setActiveState} />
                    {activeState === 'summary' &&
                        <GeneralTab
                            activeField={activeFieldForActivities}
                            setActiveField={setActiveFieldForActivities}
                            cuadrillas={cuadrillas}
                            onClickViewActivities={onClickVerActividades}
                            onChangeActivitiesField={onChangeActivitiesField}
                            executedDate={executedDate}
                            setExecutedDate={setExecutedDate}
                            numeroCuadrilla={numeroCuadrilla}
                            setNumeroCuadrilla={setNumeroCuadrilla}
                            groupAssigned={groupAssigned}
                        />}
                    {activeState === 'activities' &&
                        <ActivitiesList
                            ActiveCuadrilla={ActiveCuadrilla}
                            setActiveCuadrilla={setActiveCuadrilla}
                            activities={activities}
                            cuadrillas={cuadrillas}
                            onChangeActivitiesField={onChangeActivitiesField}
                            activeFieldForActivities={activeFieldForActivities}
                            errors={errors}
                        />}
                    {activeState === 'carts' &&
                        <CartsList
                            carts={carts}
                            activeFieldForActivities={activeFieldForActivities}
                            onClickViewCart={onClickViewCartFromCard}
                            onChangeActivitiesField={onChangeActivitiesField} />}
                    {activeState === 'errors' && <ErrorList errors={errors} />}
                    {activeState === 'files' &&
                        <ButtonsTab
                            onDownloadPdf={onClickShowPdfList}
                            onClickUploadActivities={onClickUploadActivities}
                            errors={errors}
                        />
                    }

                </div>
                <div className="consolidate_files_container_button_container"></div>
            </div>
            {/* </div> */}
        </>
    )
}
